export default __webpack_public_path__ + "static/media/logomovil.be2fa717.svg";